// extracted by mini-css-extract-plugin
export default {"container":"media-job_container__3npnb","dimText":"media-job_dimText__xG2FS"};